'use client'

import { useEffect } from 'react'

import { CenteredLayout } from '@mntn-dev/app-ui-components/centered-layout'
import { logger } from '@mntn-dev/logger'

import { ErrorLayout } from '~/components/error/error-layout.tsx'

export default function Page({
  error,
}: {
  error: Error & { digest?: string }
}) {
  const { message, digest } = error

  useEffect(() => {
    logger.error(`Error Page [digest:${digest}] ${message}`, {
      digest,
      message,
    })
  }, [digest, message])

  // currently this error object does not return an error code, so for now we assume it is always 500.
  return (
    <CenteredLayout>
      <ErrorLayout code={500} />
    </CenteredLayout>
  )
}
